import { DefaultSla } from '@provision/service-level-utils';

export { TRIAL_MEMBERSHIP_LENGTH_DAYS } from 'src/components/ActivateTrialMembershipModal/trial-length';

/**
 * The only plans Basic Support may activate as a one-time trial. Essentials
 * Plus only to start (1V-6166); Priority may come back later.
 */
export const TRIAL_MEMBERSHIP_PLATFORM_SLA_IDS: string[] = [DefaultSla.EssentialsPlus];

export enum ActivateTrialMembershipFormField {
  PartnerProductId = 'partnerProductId',
  ActiveUntil = 'activeUntil',
}
